import { useRef, useState } from 'react';

import axios from 'axios';

import { useAuthAccess } from './useAuthAccess';

import { getEnvConfigs } from "../configs/envConfigs"

let callCancelAction

const _config = {
    baseUrl: getEnvConfigs().AppApiUrl,
}

export const configuration = {
    enableServerClientCancellation: {
        id: `enableServerClientCancellation`,
        defaultValue: false
    }
}

export function useServerClient(_jwtToken = "") {

    // const controllerRef = useRef(new AbortController());

    // console.log('_jwtToken', _jwtToken)

    const { authData } = useAuthAccess();

    let cancelSource = null

    const getAuthorization = () => {

        let header = `Bearer`
        let token = ``

        // check the token is pass in via parameters
        if (_jwtToken) {
            token = _jwtToken
        } else {
            let jwtTokenFromAuth = authData?.token

            if (jwtTokenFromAuth) {
                token = jwtTokenFromAuth
            }
        }

        if (!token) return null

        return `${header} ${token}`
    }

    const createAxiosInstance = () => {

        let connection = axios.create({
            baseURL: _config.baseUrl,
            // timeout: 30000,
            // timeout: 90000,
            timeout: 180000,
            // method: "no-cors"
        })

        let cancelToken = axios.CancelToken
        cancelSource = cancelToken.source()

        return {
            serverClient: axios,
            connection,
            cancelToken
        }
    }

    const getError = (status, message = '') => (
        {
            status,
            message
        }
    )

    const getSuccess = (status, message = '', data, warning) => (
        {
            status,
            message,
            data,
            warning
        }
    )

    const parseResponse = (response) => {

        // header header status
        if (isRequestSuccess(response) === false) {
            // throw new Error(`Server Failed`)
            throw getError(false, `Server Failed`)
        }

        // check header status
        if (isResultSuccess(response) === false) {
            // throw new Error(`${response?.data?.message}`)
            throw getError(false, `${response?.data?.message}`)
        }

        const { status, message, data, warning } = response?.data ? response.data : {}

        return getSuccess(Boolean(status), message, data, warning);

    }

    const isRequestSuccess = (response) => {
        if (response.status === 200) {
            return true;
        }
        return false;
    }

    const isResultSuccess = (response) => {

        if (response?.data?.status) {
            return true;
        }
        return false;
    }

    const {
        serverClient,
        connection: serverClientConnection,
        cancelToken: serverClientCancelToken,
    } = createAxiosInstance()
    // useRef(createAxiosInstance());

    const headerAuthorization = getAuthorization()

    const makeCall = async ({ url, payload, method, configuration = {} }) => {

        const headers = {
            // 'X-Custom-Header': 'foobar'
            // "Authorization": getAuthorization(),
            'Content-Type': 'application/json',
            // 'AA': JSON.stringify(authData)
            // 'Access-Control-Allow-Headers': 'Content-Type,Authorization',
            // 'Access-Control-Allow-Origin': '*',
            // 'Access-Control-Allow-Methods': 'POST, PUT, PATCH, GET, DELETE, OPTIONS',
            // 'Access-Control-Request-Headers': '*',
            // 'Access-Control-Request-Method': 'POST, PUT, PATCH, GET, DELETE, OPTIONS',
            // 'Access-Control-Allow-Credentials': "true",
            // 'X-Atlassian-Token': 'nocheck',
        };

        // console.log('headers, headers', headers)

        if (headerAuthorization) {
            // headers.Authorization = getAuthorization(authData?.token)
            headers.Authorization = headerAuthorization
        }

        let CancelToken = serverClientCancelToken

        if (callCancelAction) {
            callCancelAction()
        }

        let request = {
            data: payload,
            method,
            url,
            headers
        }

        // check for configuration
        if (configuration?.enableServerClientCancellation) {
            request.cancelToken = new CancelToken((c) => {
                // An executor function receives a cancel function as a parameter
                callCancelAction = c;
            })
        }

        // const response = await serverClient.current.request(
        const response = await serverClientConnection.request(request);

        console.table(url, JSON.stringify(payload))

        return parseResponse(response);

    }

    const makeUploadCall = async ({ url, formData, onUploadProgress, /* onDownloadProgress */ }) => {

        const headers = {
            // 'X-Custom-Header': 'foobar'
            // "Authorization": getAuthorization(),
            'Content-Type': 'multipart/form-data',
            // 'AA': JSON.stringify(authData)
            // 'Access-Control-Allow-Headers': 'Content-Type,Authorization',
            // 'Access-Control-Allow-Origin': '*',
            // 'Access-Control-Allow-Methods': 'POST, PUT, PATCH, GET, DELETE, OPTIONS',
            // 'Access-Control-Request-Headers': '*',
            // 'Access-Control-Request-Method' : 'POST, PUT, PATCH, GET, DELETE, OPTIONS',
            // 'Access-Control-Allow-Credentials': "true",
            // 'X-Atlassian-Token': 'nocheck',
        };

        if (headerAuthorization) {
            headers.Authorization = headerAuthorization
        }

        // console.log('url', url, formData)

        // const response = await serverClient.current.post(url, formData, {
        const response = await serverClientConnection.post(url, formData, {
            headers,
            onUploadProgress,
            // onDownloadProgress
        });

        return parseResponse(response);

    }

    return { makeCall, makeUploadCall, getError, serverClient }
}